import React from 'react'
import PropTypes from 'prop-types'

import Lottie from 'react-lottie'
import animationData from './download.json'

export default function UncontrolledLottie({ style }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }
  return <Lottie options={defaultOptions} height={24} width={24} style={style} />
}

UncontrolledLottie.propTypes = {
  style: PropTypes.shape({})
}

UncontrolledLottie.defaultProps = {
  style: {}
}
